'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/**
 * Determine whether the object is a string.
 *
 * @param {mixed} object
 *
 * @return {bool}
 */


var isString = function isString(object) {
  return typeof object === 'string';
};
/**
 * Determine whether the object is an instance of Moment.
 *
 * @param {mixed} object
 *
 * @return {bool}
 */


var isMoment = function isMoment(object) {
  return _moment2.default.isMoment(object);
};
/**
 * Determine whether the object is an instance of Date (JavaScript standard library).
 *
 * @param {mixed} object
 *
 * @return {bool}
 */


var isDate = function isDate(object) {
  return object instanceof Date;
};
/**
 * Determine whether a number is a valid month number (0-11).
 *
 * @param {number} number
 *
 * @return {bool}
 */


var isValidMonthNumber = function isValidMonthNumber(number) {
  return !isNaN(number) && number >= 0 && number <= 11;
};
/**
 * Determine whether a number is a valid year number.
 *
 * @param {number} number
 *
 * @return {bool}
 */


var isValidYearNumber = function isValidYearNumber(number) {
  return !isNaN(number);
};

exports.default = {
  isString: isString,
  isMoment: isMoment,
  isDate: isDate,
  isValidMonthNumber: isValidMonthNumber,
  isValidYearNumber: isValidYearNumber
};